import { blockText, parseNarrative } from "@hamlak/shared";
import type { ConversationListItem } from "@/api/types";

/** 목록 한 줄 미리보기: 마크다운 마커는 떼고 턴의 대사(말풍선) 블록은 따옴표로, 속마음은 작은따옴표로 감싼다(시안 F03-01, AC0-244). 첫 장면(intro)은 블록 타입이 지문·대사를 정하므로 따옴표 없이. 줄바꿈·연속 공백은 한 칸 */
export function previewText(preview: ConversationListItem["preview"]): string {
  if (!preview) return "";
  const quote = preview.source === "turn";
  // 서버가 120자에서 자르므로 열린 `*` 는 스트리밍과 같은 규칙으로 닫는다
  return parseNarrative(preview.text, { streaming: true })
    .map((b) => {
      const s = blockText(b).replace(/\s+/g, " ").trim();
      if (!quote || !s) return s;
      return b.kind === "dialogue" ? `"${s}"` : b.kind === "thought" ? `'${s}'` : s;
    })
    .filter(Boolean)
    .join(" ");
}
